import React, {useState, useEffect, Fragment} from 'react'
import Image from '../Image';
import { useHistory, useLocation } from 'react-router-dom';
import ProductAdd from '../ProductAdd';
import plate from '../../../assets/img/icon-plate.svg';
import W from '../Word';
import { useTranslation } from 'react-i18next';
import { currentLang } from '../../../utils/functions';
import parse from 'html-react-parser';
import {isNil, isEmpty} from 'lodash';

const ProductContent = ({data, handleBasket, createURL, raw_data, perperson}) => {
    const [userSum, setUserSum] = useState(0);
    const [totalPack, setTotalPack] = useState(0);
    const [cutPackages, setCutPackages] = useState(null);
    const [totalCutPackages, setTotalCutPackages] = useState(null);
    const [mincedPackages, setMincedPackages] = useState(null);
    const [packageSumStyle, setPackageSumStyle] = useState("text--green");
    const [alertTotalPackages, setAlertTotalPackages] = useState(null);
    //const [vacuumsPlural, setVacuumsPlural] = useState('');
    const [diffTotalPack, setDiffTotalPack] = useState(0);
    const [params, setParams] = useState({});
    const [url, setUrl] = useState({});
    const { t } = useTranslation();
    const { pathname } = useLocation();
    
    var perperson_fixed = perperson.toFixed(2).replace('.', t('price_format_replace'));

    useEffect(() => {
        //console.log(data);
        //console.log(raw_data.packages);
    }, [pathname])
    //console.log(perperson);
    useEffect(() => {
        
       var total = 0;
       var totalCuts = 0;
       var haveMinced = 0;
       data.map(item => {
            if(item.shop_packageproduct_type == 'cut'){
                setCutPackages(item.cut_packages);

                if(item.cut_packages !== undefined){
                    total += item.cut_packages.reduce(function(i, val) { return i + val.meals; }, 0);
                    totalCuts += item.cut_packages.reduce(function(i, val) { return i + val.meals; }, 0);
                    //setUserSum(userSum + total);
                }
            }

            if(item.shop_packageproduct_type == 'minced'){
                setMincedPackages(item.minced_packages);
                total += item.minced_packages.reduce(function(i, val) { return i + val.meals; }, 0);
                //setUserSum(userSum+total);
                //setTotalCuts(totalCuts + total);


                var firstParams = {};
                if(item.minced_packages){
                    item.minced_packages.map(item=>{
                        firstParams[item.name] = item.meals;
                        //return item.name + "=" + item.meals;
                    }).join("&");
                }
                //setUrl(firstUrl);
                setParams(firstParams);
                haveMinced = 1;
            }
            setTotalPack(total);
            setUserSum(total);
       });
       setTotalCutPackages(totalCuts);
       if(haveMinced == 0){
           createURL({});
       }

    }, [data, pathname]);
//console.log(data);

    useEffect(() => {
        if(userSum != totalPack){
            setPackageSumStyle("text--red");
            handleBasket(0);
            if(userSum > totalPack) {
              setAlertTotalPackages(t("product.product_content_remove"));
              setDiffTotalPack( userSum - totalPack );
            } else {
              setAlertTotalPackages(t("product.product_content_pickmore"));
              setDiffTotalPack( totalPack - userSum );
            }
        }else{
            setPackageSumStyle("text--green");
            handleBasket(1);
            setDiffTotalPack(0);
        }
      }, [userSum]);

    const sum = value =>{
        if(value > 0){
            setUserSum(userSum+1);
            setDiffTotalPack(diffTotalPack+1);
            handleBasket(0);
        }else{
          setUserSum(userSum-1);
          handleBasket(1);
          setDiffTotalPack(diffTotalPack-1);
        }
    }
    useEffect(() => {
        //console.log(params);
        if(!isEmpty(params)){
            var total = 0;
            for(var i in params){
                total += params[i];
            }
            //console.log(totalCutPackages);
            //console.log(total);
            setUserSum(totalCutPackages+total);
            //console.log(params);
        }
        createURL(params);

    }, [params])

    const urlChange = (name, value) =>{
        //console.log(name, value)
        setParams({...params, [name]: value});
        //console.log(params)
    }
    return (
        <div className="row" id="productContent">
            <div className="col-12 text-sm-center text-md-left mt-15">
                <h4 className="heading--h4"><W>product.content.package-content</W></h4>
                <p>
                    {raw_data.package_content_description && parse(raw_data.package_content_description)}
                </p>
            </div>

            <div className="col-12 package__content">
                <div className="row th">
                    <div className="col-5 col-md-6 col-xl-6">
                        <W>product.content.meat-product</W>
                    </div>
                    <div className="col-4 col-md-3 col-xl-4">
                        <W>product.content.number</W>
                    </div>
                    <div className="col-3 col-md-3 col-xl-2">
                        <W>abtest.meals</W>
                    </div>
                </div>
                <div className="row tbody">
                {cutPackages && cutPackages.map((item, index) => {
                    return (
                        <Fragment>
                            <div className="row border package__row" key={index}>
                                <div className="col-5 col-md-6 col-xl-6">
                                    <a href={"/"+currentLang()+"/"+t("menu.meatcuts")+"/"+item.frontend_name_detailpage}>
                                    {item.frontend_name}
                                    </a>
                                </div>
                                <div className="col-4 col-md-3 col-xl-4">
                                    {item.total_pieces} <W count={item.total_pieces} type="interval">product.{item.unit_single}</W>
                                </div>
                                <div className="col-3 col-md-3 col-xl-2">
                                    <div className="package__meals">
                                        ≃ {item.total_pieces} x {item.weight}g
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    )
                })}
                {mincedPackages && mincedPackages.map((item, index) => {
                    return (
                        <ProductAdd key={index} defaultValue={item.meals} packageInfo={item} parentCallback={sum} urlChange={urlChange} />
                    )
                })}

                </div>

                <div className="row tfoot mt-10 mb-10">
                    <div className="col-xxl-6 col-xl-12 order-xxl-1">
                      <span className={`alert__total-vacuums bg--red mb-2 text--white align__right ${diffTotalPack != 0 ? 'active' : ''}`}><i className={"icon-warning"}></i> {alertTotalPackages} {diffTotalPack} <W>packages</W>{diffTotalPack != 1 ? "s" : ""}</span>
                    </div>
                    <div className="col-xxl-6 col-xl-12 order-xxl-0">
                        {parse(t('abtest.content_footer', {totalPack: totalPack * 2}))}<br />
                        {parse(t('abtest.content_footer2', {perperson: perperson_fixed}))}<br />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductContent
